// The same bundle talks to the backend serving it on LAN and on cPanel.
export const AUTH_API_BASE = "/api";
export const REPORTS_API_ROOT = "";
export const REPORTS_API_BASE = "/api";
